import React, { useEffect, useState } from "react";
import {
  getCustomerSocialReasonDatatable
} from "../../../../services/CatalogService.js";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import CustomerSocialReasonTable from "./formCustomerSocialReason/CustomerSocialReasonTable.js"; 

function VaroExpressCustomerSocialR() {
  const razonSocial = 'VaroExpress';

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("id");
  const [sortDirection, setSortDirection] = useState("asc");
  const editBasePath = "/billing-VaroExpress/CustomerSocialReason/edit";

  const fetchData = async (page = 1, search = "", sort = "id", dir = "asc") => {
    try {
      const response = await getCustomerSocialReasonDatatable({
        draw: page,
        start: (page - 1) * rowsPerPage,
        length: rowsPerPage,
        search,
        sort,
        dir,
        razonSocial
      });
      setData(response);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData(currentPage, searchValue, sortField, sortDirection);
  }, [currentPage, rowsPerPage, sortField, sortDirection]);
 

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item active">Clientes razón social - Varo Express</li>
          </ol>
          <h1 className="page-header mb-0">Clientes razón social - Varo Express</h1>
        </div>
        <div className="ms-auto">
          <Link
            to="/billing-VaroExpress/NewCustomerSocialReason"
            className="btn btn-success btn-rounded px-4 rounded-pill"
          >
            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>{" "}
            Nuevo Cliente
          </Link>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Listado de Clientes</PanelHeader>
            <PanelBody>
              <CustomerSocialReasonTable
                data={data}
                loading={loading}
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                sortField={sortField}
                sortDirection={sortDirection}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                setCurrentPage={setCurrentPage}
                setRowsPerPage={setRowsPerPage}
                setSortField={setSortField}
                setSortDirection={setSortDirection}
                fetchData={fetchData}
                razonSocial={razonSocial}
                editBaseRuta={editBasePath}
              />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default VaroExpressCustomerSocialR;
